import React from "react";
import styled, { css } from "styled-components";
import Media from "react-media";

const Category = styled.button`
  position: relative;
  display: inline-block;
  width: 100%;
  height: 37px;
  padding-left: 13px;
  padding-right: 6px;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1;
  color: #99959d;
  text-align: left;
  text-transform: uppercase;
  background-color: transparent;
  border: none;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.tradeHeaderAccent};
  }

  ${props =>
    props.active &&
    css`
      color: ${({ theme }) => theme.foreground};
      background-color: ${props => props.theme.popupDarkBackground};
      &:hover {
        color: ${({ theme }) => theme.foreground};
      }
    `};

  @media (max-width: 959px) {
    font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "10px"};
  }
`;

const Icon = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 19px;
  margin-top: -2px;
  margin-right: 10px;
  color: #99959d;
  line-height: 0;

  ${props =>
    props.active &&
    css`
      color: ${({ theme }) => theme.foreground};
    `};
`;

function StockCategory(props){
  const handleClick = () => {
    return () => props.onClick(props.category);
  };

  return(
    <Media query={{ minWidth: 960 }}>
        {matches => (
          <div
            style={{
              position: "relative",
              marginBottom: 3
            }}
          >
            <Category
              active={props.active}
              onClick={handleClick()}
              onMouseEnter={
                matches ? () => props.showInfo(props.category) : null
              }
              onMouseLeave={matches ? props.hideInfo : null}
            >
              <Icon active={props.active}>{props.Icon}</Icon>
              {props.title}
            </Category>
          </div>
        )}
      </Media>
  )
}

export default StockCategory;



// WEBPACK FOOTER //
// ./src/components/StockMenu/StockCategory.js